import BasicInfo from './base-info';

export default BasicInfo;
